import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../contexts/AuthProvider";
import AuthService from '../services/AuthService';
import './LoginComponent.css';

const logos = [
  { src: '/images/carbon-accounting-svgrepo-com.svg', alt: 'Carbon' },
  { src: '/images/digital-id-svgrepo-com.svg', alt: 'Digital' },
  { src: '/images/earth-9-svgrepo-com.svg', alt: 'Earth' },
  { src: '/images/recycle-svgrepo-com.svg', alt: 'Recycle' },
  { src: '/images/recycling-water-svgrepo-com.svg', alt: 'Water' },
];

const LoginComponent = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setToken } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setIsSubmitting(true);
      const response = await AuthService.login(email, password);
      if (response.data.accessToken) {
        setToken(response.data.accessToken);
        navigate("/dashboard", { replace: true });
      } else {
        setToken(null);
        setError('Login succeeded but no token received');
      }
    } catch (error) {
      setToken(null);
      setError('Giris yapilirken bir hata oluştu. Lütfen kullanici e-posta adresini ve sifrenizi kontrol edin.');
    }finally {
      setIsSubmitting(false);
    }
  };

  const routeToSignUp = (e) => {
    e.preventDefault();
    navigate("https://rens.co/demo-request", { replace: false });
  };

  return (
    <div className="login-container">
      <div className="background">
        {logos.map((logo, index) => (
          <div key={index} className={`icon-holder icon-holder${index + 1}`}>
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </div>
      <div className="semi-transparent-container"></div>
      <div className="login-card">
        <img src="/images/rens_logo.svg" alt="Your logo" className="logo" />
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              placeholder="username@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <a href="/forgot-password" className="forgot-password">Şifrenizi unuttunuz mu?</a>
          {error && <p style={{ color: '#ff6b6b', textAlign: 'center', marginBottom: '20px' }}>{error}</p>}
          <button type="submit" className="hero-button">
                        
            {isSubmitting ? <div 
            className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2" 
            style={{ borderColor: '#0F4A46', backgroundColor: 'rgba(211, 211, 211, 0.4)' }}
            ></div> : 'Giriş Yap'}
            
          </button>
        </form>
        <p className="register-prompt">
          Henüz hesabınız yok mu? <a href="https://rens.co/demo-request" >Deneme sürümü talep et</a>
        </p>
      </div>
    </div>
  );
};

export default LoginComponent;